import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { IToolbarSelectorParams } from "../../app/models/toolbar";
import { RootStoreContext } from "../../app/stores/rootStore";
import GenericToolbar from "./GenericToolbar";
import MobileToolbar from "./MobileToolbar";
const ToolbarSelector: React.FC<IToolbarSelectorParams> = ({
  items,
  languageSelectionConfig,
  contentConfig,
  isSidebarOpen,
  stickyButton,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { isMobileMediaQuery } = rootStore.responsiveStore;

  return (
    <>
      {isMobileMediaQuery ? (
        <MobileToolbar
          languageSelectionConfig={languageSelectionConfig}
          contentConfig={contentConfig}
        />
      ) : (
        <GenericToolbar
          items={items}
          languageSelectionConfig={languageSelectionConfig}
          contentConfig={contentConfig}
          isSidebarOpen={isSidebarOpen}
          stickyButton={stickyButton}
        />
      )}
    </>
  );
};

export default observer(ToolbarSelector);
